var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_1480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2679 8.82001C8.18833 8.82001 8.11202 8.7884 8.05576 8.73214C7.9995 8.67588 7.9679 8.59957 7.9679 8.52001C7.9679 8.44044 7.9995 8.36414 8.05576 8.30788C8.11202 8.25162 8.18833 8.22001 8.2679 8.22001",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26782 8.82001C8.34739 8.82001 8.42369 8.7884 8.47995 8.73214C8.53622 8.67588 8.56782 8.59957 8.56782 8.52001C8.56782 8.44044 8.53622 8.36414 8.47995 8.30788C8.42369 8.25162 8.34739 8.22001 8.26782 8.22001",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7321 8.82001C15.6526 8.82001 15.5763 8.7884 15.52 8.73214C15.4637 8.67588 15.4321 8.59957 15.4321 8.52001C15.4321 8.44044 15.4637 8.36414 15.52 8.30788C15.5763 8.25162 15.6526 8.22001 15.7321 8.22001",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7322 8.82001C15.8117 8.82001 15.888 8.7884 15.9443 8.73214C16.0006 8.67588 16.0322 8.59957 16.0322 8.52001C16.0322 8.44044 16.0006 8.36414 15.9443 8.30788C15.888 8.25162 15.8117 8.22001 15.7322 8.22001",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 18.996C13.5392 18.996 15.0153 18.3846 16.1036 17.2963C17.1919 16.208 17.8033 14.7319 17.8033 13.1928H6.1969C6.1969 14.7319 6.80831 16.208 7.89662 17.2963C8.98493 18.3846 10.461 18.996 12.0001 18.996Z",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0048 1.2C10.0408 1.20066 8.11402 1.73603 6.43123 2.74867C4.74843 3.7613 3.37309 5.213 2.45276 6.948C1.53545 8.68254 1.10983 10.6349 1.22192 12.5938C1.33402 14.5528 1.97957 16.4438 3.08876 18.0624L1.20476 22.8L6.24476 21.1008C7.66121 21.9893 9.26439 22.5372 10.9283 22.7016C12.5923 22.8659 14.2717 22.6422 15.8346 22.048C17.3975 21.4537 18.8013 20.5052 19.9358 19.2769C21.0702 18.0486 21.9044 16.5739 22.3728 14.9688C22.8373 13.3641 22.9217 11.6732 22.6193 10.0303C22.3168 8.38726 21.6359 6.8373 20.6304 5.5032C19.6243 4.16664 18.3215 3.08217 16.8245 2.33538C15.3276 1.58859 13.6776 1.1999 12.0048 1.2Z",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_1480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSmiley);
export default __webpack_public_path__ + "static/media/chat-smiley.087a95e25076f4924a7ef69aab7a0bae.svg";
export { ForwardRef as ReactComponent };